import api from './api';

export const voiceService = {
  /**
   * Загрузить голосовую заметку
   */
  async uploadVoiceNote(leadId, audioBlob, duration, mimeType) {
    const formData = new FormData();
    
    // Определяем расширение файла
    const extension = mimeType.includes('mp4') ? 'mp4' : 
                      mimeType.includes('webm') ? 'webm' : 'audio';
    
    formData.append('file', audioBlob, `voice_note.${extension}`);
    formData.append('duration', duration.toString());
    
    // НЕ устанавливаем Content-Type - браузер сам установит multipart/form-data с boundary
    const response = await api.post(`/leads/${leadId}/voice-note`, formData);
    
    return response.data;
  },

  /**
   * Удалить голосовую заметку
   */
  async deleteVoiceNote(leadId) {
    const response = await api.delete(`/leads/${leadId}/voice-note`);
    return response.data;
  },
};
